// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Payload Destructure
// Modified Date: 18-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import CloseLoanActionTypes from './close-loan.types';

import {
	closeLoanMemberListGet,
	closeLoanMemberListUpdate,
	closeLoanMemberListRevert,
} from './close-loan.service';

import {
	getCloseLoanDetailsSuccess,
	getCloseLoanDetailsFailure,
	getCloseLoanDetailsResponseChanged,
	updateCloseLoanDetailsSuccess,
	updateCloseLoanDetailsFailure,
	updateCloseLoanDetailsResponseChanged,
	revertCloseLoanDetailsSuccess,
	revertCloseLoanDetailsFailure,
	revertCloseLoanDetailsResponseChanged,
} from './close-loan.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  GET CLOSE LOAN LIST START  ******************** */
export function* getcloseLoanMemberList({ payload }: any) {
	try {
		const { companyID, userID, branchID, centerID, groupID, databaseName, closeDate } = payload;
		const key = 'GetGroupMemberDetailsForCloseDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			CloseDate: closeDate,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(closeLoanMemberListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCloseLoanDetailsFailure(responseData.data));
		} else {
			yield put(getCloseLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCloseLoanDetailsFailure(error));
	}
}

export function* resetGetInActiveMemberListResponse() {
	yield put(getCloseLoanDetailsResponseChanged());
}

export function* onGetInActiveMemberListDetails() {
	yield takeLatest(CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_START, getcloseLoanMemberList);
}

export function* onGetInActiveMemberListResponseReset() {
	yield takeLatest(
		CloseLoanActionTypes.GET_CLOSE_LOAN_LIST_RESPONSE_RESET,
		resetGetInActiveMemberListResponse,
	);
}
/** ********************* GET CLOSE LOAN LIST START END ******************** */

/** *********************  UPDATE CLOSE LOAN START  ******************** */
export function* updatecloseLoanMemberList({ payload }: any) {
	try {
		const key = 'UpdateGroupMemberDetailsForCloseKey';
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			userLevel,
			infogCompanyID,
			branchID,
			centerID,
			groupID,
			databaseName,
			closeDate,
			closeloansubmitlistArr,
			closeCollectAll,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			UserLevel: userLevel,
			InfogCompanyID: infogCompanyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			CloseDate: closeDate,
			CloseLoanArr: JSON.stringify(closeloansubmitlistArr).replace(/"/g, "'"),
			CloseCollectAll: closeCollectAll,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(closeLoanMemberListUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCloseLoanDetailsFailure(responseData.data));
		} else {
			yield put(updateCloseLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCloseLoanDetailsFailure(error));
	}
}

export function* resetUpdateInActiveMemberListResponse() {
	yield put(updateCloseLoanDetailsResponseChanged());
}

export function* onUpdateInActiveMemberListDetails() {
	yield takeLatest(CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_START, updatecloseLoanMemberList);
}

export function* onUpdateInActiveMemberListResponseReset() {
	yield takeLatest(
		CloseLoanActionTypes.UPDATE_CLOSE_LOAN_LIST_RESPONSE_RESET,
		resetUpdateInActiveMemberListResponse,
	);
}
/** ********************* UPDATE CLOSE LOAN START END ******************** */

/** *********************  REVERT CLOSE LOAN START  ******************** */
export function* revertcloseLoanMemberList({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			userName,
			userAccessBranchID,
			userLevel,
			infogCompanyID,
			branchID,
			centerID,
			groupID,
			databaseName,
			closeDate,
			closeloanIndexID,
			loanIndexGroupMemberID,
			memberID,
		} = payload;
		const key = 'RevertGroupMemberDetailsForCloseKey';
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			UserLevel: userLevel,
			InfogCompanyID: infogCompanyID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			CloseDate: closeDate,
			LoanIndexID: closeloanIndexID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(closeLoanMemberListRevert, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertCloseLoanDetailsFailure(responseData.data));
		} else {
			yield put(revertCloseLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertCloseLoanDetailsFailure(error));
	}
}

export function* resetRevertInActiveMemberListResponse() {
	yield put(revertCloseLoanDetailsResponseChanged());
}

export function* onRevertInActiveMemberListDetails() {
	yield takeLatest(CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_START, revertcloseLoanMemberList);
}

export function* onRevertInActiveMemberListResponseReset() {
	yield takeLatest(
		CloseLoanActionTypes.REVERT_CLOSE_LOAN_LIST_RESPONSE_RESET,
		resetRevertInActiveMemberListResponse,
	);
}
/** ********************* REVERT CLOSE LOAN START END ******************** */

export function* CloseLoanMemberSaga() {
	yield all([
		call(onGetInActiveMemberListDetails),
		call(onGetInActiveMemberListResponseReset),
		call(onUpdateInActiveMemberListDetails),
		call(onUpdateInActiveMemberListResponseReset),
		call(onRevertInActiveMemberListDetails),
		call(onRevertInActiveMemberListResponseReset),
	]);
}
